<template>
  <div
    class="custom-pagination"
    :class="{radius: radius}"
    v-if="total"
  >
    <div class="total-num">
      <span class="text">{{ $t('customPagination.gong') }}{{total}}{{ $t('customPagination.tiao_shu_ju') }}</span>
      <div class="total-num-append">
        <slot name="totalNumAppend"></slot>
      </div>
    </div>
    <div class="r">
      <div
        class="pages"
        v-if="sizes && sizes.length && selfSize"
      >
        <custom-select
          :auto="false"
          :data="sizesData"
          :radius="true"
          :clearable="false"
          v-model="selfSize"
          @change="onSizeChange"
        ></custom-select>
      </div>
      <div
        class="btn-prev"
        :class="curPage <= 1 ? 'disabled' : ''"
        @click="onPrev"
      >
        <i class="icon icon-zuo1"></i>
      </div>
      <div
        class="pagination"
        @click="clickPagination"
      >
        <div
          v-if="!paginationActive"
          class="preview"
        >{{curPage}}/{{totalPage}}</div>
        <input
          v-if="paginationActive"
          v-model="editPage"
          class="edit-val"
          ref="text"
          type="number"
          autocomplete="off"
          @keydown.enter="onConfirm"
          @blur="onBlur"
        >
      </div>
      <div
        class="btn-next"
        :class="curPage >= totalPage ? 'disabled' : ''"
        @click="onNext"
      >
        <i class="icon icon-you1"></i>
      </div>
    </div>
  </div>
</template>

<script>
/** 分页组件 */

export default {
  name: 'custom-pagination',
  mixins: [],
  components: {},
  props: {
    // 是否为圆角样式
    radius: {
      type: Boolean,
      default: false
    },
    // 总条数
    total: {
      type: Number,
      default: 0,
    },
    // 当前页
    page: {
      type: Number,
      default: 1,
    },
    // 页面条数
    size: {
      type: [Number, String],
      default: 16,
    },
    // 分页器数据
    sizes: {
      type: [Array, Boolean],
      default() {
        return [
          10, 20, 30, 50, 100, 200
        ];
      }
    }
  },
  data() {
    return {
      curPage: 1,
      editPage: 1,
      paginationActive: false,
      selfSize: '',
    };
  },
  computed: {
    totalPage() {
      if (this.total && this.selfSize) {
        return Math.ceil(this.total / this.selfSize);
      }
      return 0;
    },
    sizesData() {
      return this.sizes.map(num => ({
        name: this.$t('customPagination.oo', [num,this.$t('customPagination.ye')]),
        value: num
      }));
    },
  },
  watch: {
    page: {
      immediate: true,
      handler(val) {
        this.curPage = val;
      },
    },
    size: {
      immediate: true,
      handler(val) {
        this.selfSize = val;
      }
    }
  },
  filters: {},
  directives: {},
  methods: {
    clickPagination() {
      if (!this.paginationActive) {
        this.paginationActive = true;
        this.editPage = this.curPage;
        this.$nextTick(() => {
          this.$refs.text.focus();
        });
      }
    },
    isNum(val) {
      const pattern = /\d+/;
      return pattern.test(val);
    },
    emitChange() {
      this.$emit('change', {
        page: this.curPage,
        size: this.selfSize,
      });
    },
    onConfirm() {
      this.formatCurPageByVal(this.editPage);
      this.paginationActive = false;
      this.emitChange();
    },
    formatCurPageByVal(val) {
      const editPage = val;
      let checkNum = editPage;
      if (typeof editPage === 'string') {
        if (this.isNum(editPage)) {
          checkNum = Math.floor(Number(editPage));
        } else {
          return;
        }
      }
      if (checkNum < 1) {
        this.curPage = 1;
      } else if (checkNum > this.totalPage) {
        this.curPage = Math.max(this.totalPage, 1);
      } else {
        this.curPage = checkNum;
      }
    },
    onBlur() {
      this.paginationActive = false;
    },
    onPrev() {
      if (this.curPage <= 1) {
        return;
      }
      this.curPage--;
      this.emitChange();
    },
    onNext() {
      if (this.curPage >= this.totalPage) {
        return;
      }
      this.curPage++;
      this.emitChange();
    },

    onSizeChange() {
      this.curPage = 1;
      this.emitChange();
    }
  },
  created() { },
  mounted() { },
};
</script>

<style lang="scss">
.custom-pagination {
  overflow: hidden;
  display: inline-block;
  width: 100%;
  padding: 24px;
  background: #fff;

  &.radius {
    border-radius: 16px;
  }

  .total-num {
    float: left;

    .text {
      float: left;
      color: #4d4d4d;
      font-size: 14px;
      font-family: DIN 2014;
      line-height: 40px;
    }

    .total-num-append {
      float: left;
    }
  }

  .r {
    float: right;
  }
  .pages {
    float: left;
    margin-right: 16px;
    width: 106px;

    .custom-select .el-input .el-input__inner {
      height: 40px;
      line-height: 40px;
      padding-left: 20px;
    }

    .custom-select .el-input .el-input__suffix .el-select__caret {
      line-height: 40px;
    }

    .custom-select .el-input .el-input__suffix .el-icon-arrow-up:before {
      font-size: 18px;
      color: #202945;
    }
  }
  .btn-prev {
    float: left;
  }
  .btn-next {
    float: left;
  }
  .btn-prev,
  .btn-next {
    $r: 40px;
    cursor: pointer;
    width: $r;
    height: $r;
    border-radius: 100%;
    background: #fff;
    color: #202945;
    text-align: center;
    line-height: $r;
    font-size: 12px;
    box-shadow: 0 0 0 2px #202945 inset;

    &.disabled {
      .icon {
        color: #e6e6e6;
      }
      &.btn-prev,
      &.btn-next {
        box-shadow: 0 0 0 2px #e6e6e6 inset;
      }
    }

    .icon {
      font-size: 24px;
      font-weight: bold;
    }
  }
  .pagination {
    cursor: pointer;
    float: left;
    margin-left: 16px;
    margin-right: 16px;
    box-shadow: 0 0 0 1px #e6e6e6 inset;
    border-radius: 20px;
    background: #ffffff;
    line-height: 40px;
    width: 80px;
    height: 40px;
    overflow: hidden;

    .preview {
      color: #1a1a1a;
      font-size: 16px;
      text-align: center;
      font-family: PingFangSC-Regular, PingFang SC;
    }

    .edit-val {
      font-family: DIN 2014;
      display: block;
      border: none;
      outline: none;
      width: 100%;
      height: 100%;
      text-align: center;
      color: #1a1a1a;
      font-size: 14px;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }
    input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
</style>
